// @flow

import clsx from 'clsx';

import { selectCartIsActive } from '@gandi/cart';
import { Select } from '@gandi/form';
import { useTranslator } from '@gandi/translate';

import { select as selectIDNLanguages } from 'src/DomainCreate/modules/selectors/idn';
import type { IDNLangAlpha2Code } from 'src/DomainCreate/types';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { GandiFormSelectOption } from './types';

import styles from './AlphabetSelect.scss';

export type Props = {
  disabled?: boolean,
  onChange?: (option: GandiFormSelectOption<IDNLangAlpha2Code>) => void,
  value?: IDNLangAlpha2Code,
  readOnly?: boolean,
  id: string,
  big?: boolean,
  className?: string,
};

const small = ['small'];

export default function AlphabetSelect({
  big,
  disabled,
  onChange,
  value,
  id,
  readOnly,
  className,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartActive = useAppSelector(selectCartIsActive);
  const values = useAppSelector(selectIDNLanguages);

  const selectedOption = values.find(opt => opt.value === value);

  const isDisabled =
    disabled !== undefined
      ? disabled || values.length === 0 || !cartActive
      : values.length === 0;

  const onSelectChange: (SyntheticEvent<HTMLSelectElement>) => void = evt => {
    const newAlphabet = values.find(
      opt => opt.value === evt.currentTarget.value,
    );
    if (onChange && newAlphabet !== undefined) {
      onChange(newAlphabet);
    }
  };

  return (
    <Select
      disabled={isDisabled}
      id={id}
      onChange={e => onSelectChange(e)}
      value={selectedOption?.value}
      values={values}
      placeholder={__('Select a language')}
      readOnly={readOnly || (!disabled && values.length === 1)}
      variant={big ? undefined : small}
      className={clsx(styles.root, className)}
    />
  );
}
